import { flatMap, filter } from 'rxjs/operators';
import { of } from 'rxjs';
import { push } from 'connected-react-router';

const maintenanceModeRedirect = (action$) =>
    action$.pipe(
        filter(({ payload }) => payload?.status === 503),
        flatMap(() => of(push('/maintenance'))),
    );

export default maintenanceModeRedirect;
